import { TextField } from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import themesConfig from 'app/fuse-configs/themesConfig'

export default makeStyles(() => ({
  headerSelect: {
    padding: '12px 5px 12px 10px',
    height: '100%',
    cursor: 'pointer',
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
    '& .MuiSelect-select': {
      fontSize: 14,
      fontWeight: 700,
      color: themesConfig.default.colors.primary,
      padding: 0,
      backgroundColor: 'transparent',
      borderRadius: 0,
      lineHeight: '20px',
      width: 'auto',
    },
  },
  invalidHeader: {
    backgroundColor: themesConfig.default.colors['orange-50'],
    '& .MuiSelect-select': {
      color: themesConfig.default.colors['orange-500'],
    },
  },
  selectIcon: {
    fontSize: 16,
    fontWeight: 700,
    marginLeft: 3,
    color: themesConfig.default.colors['grayish-blue'],
    pointerEvents: 'none',
  },
  select: {
    marginTop: 15,
    maxHeight: 300,

    '& .MuiListItem-gutters': {
      fontSize: 14,
      paddingLeft: 24,
      color: themesConfig.default.colors.primary,
      lineHeight: '20px',
    },

    '& .MuiListSubheader-gutters': {
      paddingLeft: 10,
      fontSize: 12,
      fontWeight: 400,
      color: themesConfig.default.colors['primary-300'],
      lineHeight: '30px',
    },
  },

  searchInputIcon: {
    color: themesConfig.default.colors['grey-100'],
  },
}))

export const SearchInput = withStyles({
  root: {
    padding: '5px 16px',
    backgroundColor: themesConfig.default.colors.white,
    '& .MuiOutlinedInput-root': {
      backgroundColor: themesConfig.default.colors.white,
      padding: '8px 16px',
      borderRadius: 4,

      '& .MuiOutlinedInput-input': {
        padding: 0,
        height: 20,
        fontSize: 16,
      },
      '& fieldset': {
        borderColor: themesConfig.default.colors['grey-100'],
      },
      '&:hover fieldset': {
        borderColor: themesConfig.default.colors['grey-100'],
      },
      '&.Mui-focused fieldset': {
        borderColor: themesConfig.default.colors['grey-100'],
      },
    },
  },
})(TextField)
